import { Navigate, useSearchParams } from 'react-router';

/**
 * `/sessions` folded into Bàn làm việc (spec 2026-08-22-sessions-fold §1).
 * The list screen is gone; its URL still resolves so bookmarks, the old
 * "Suất học" nav entry in anyone's history, and links shared before the fold
 * land on the same day the list would have opened on: the `?week=` anchor if
 * it carried one, else today. `/sessions/:id` is untouched.
 *
 * "Today" is expressed as the *absence* of `?date=`, never as a date computed
 * here: this component only has the browser clock, and stamping that into the
 * URL would pin a wrong day for anyone whose machine is off (or running the
 * simulated dev clock) and then keep it pinned across reloads. Bare `/` lets
 * the workbench resolve today from the server clock, every render.
 */
export function SessionsRedirect() {
  const [searchParams] = useSearchParams();
  const week = searchParams.get('week');
  const valid = week && /^\d{4}-\d{2}-\d{2}$/.test(week);
  return <Navigate replace to={valid ? `/?date=${week}` : '/'} />;
}
